import React, { useState } from "react";
import { Dialog, DialogActions, DialogContent, TextField } from "@mui/material";
import GlobalButton from "../../../shared/utils/GlobalButton";

const ClientRecceApprovalModal = ({ open, onClose, onSubmit }) => {
  const [approvalComment, setApprovalComment] = useState("");

  const handleSubmit = () => {
    onSubmit(approvalComment);
    setApprovalComment("");
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogContent>
        <label className="my-2">Approval Reason (Optional):</label>
        <TextField
          autoFocus
          margin="dense"
          label="Enter Comments"
          type="text"
          fullWidth
          value={approvalComment}
          onChange={(e) => setApprovalComment(e.target.value)}
          placeholder="Optional - you can leave this empty"
        />
      </DialogContent>
      <DialogActions>
        <GlobalButton variant="secondary" onClick={onClose}>
          {`Cancel`}
        </GlobalButton>
        <GlobalButton onClick={handleSubmit}>{`Approve`}</GlobalButton>
      </DialogActions>
    </Dialog>
  );
};

export default ClientRecceApprovalModal;
